<mulo-centered-block-layout class="portal-additions">
  <h2 class="portal-section-title">{{'research.portal.worksadded.title' | translate}}</h2>
  <esp-additions-datatable [dataSource]="worksByYear"></esp-additions-datatable>
  @if (showMetricsAdditions) {
    <esp-portal-metrics
      metric="additions"
      [worksByYear]="worksByYear"
      [totalWorks]="total | async"
    ></esp-portal-metrics>
  }
  <div (deferLoad)="showMetricsAdditions = true"></div>
</mulo-centered-block-layout>
